import React from "react";
import { X } from "lucide-react";

export default function POStatusModal({
  isOpen,
  onClose,
  po,
  newStatus,
  awardedDate,
  setAwardedDate,
  customerPoNumber,
  setCustomerPoNumber,
  onConfirm
}) {
  if (!isOpen || !po) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ width: "90%", maxWidth: "450px" }}>
        <div className="modal-header">
          <h3 style={{ margin: 0 }}>
            {newStatus === "Won" ? "Award EST" : `Mark EST as ${newStatus}`}
          </h3>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "1.25rem", marginTop: "1.25rem" }}>
          <div style={{ padding: "1rem", borderRadius: "6px", backgroundColor: "rgba(255, 255, 255, 0.02)", border: "1px solid var(--border-color)" }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: "0.5rem", fontSize: "0.9rem" }}>
              <span style={{ color: "var(--text-secondary)" }}>EST Number:</span>
              <strong style={{ color: "var(--text-primary)" }}>{po.poNumber}</strong>

              <span style={{ color: "var(--text-secondary)" }}>Client Name:</span>
              <span style={{ color: "var(--text-primary)" }}>{po.clientName}</span>

              <span style={{ color: "var(--text-secondary)" }}>Project Name:</span>
              <span style={{ color: "var(--text-primary)" }}>{po.title}</span>

              <span style={{ color: "var(--text-secondary)" }}>New Status:</span>
              <span style={{ 
                fontWeight: 600, 
                color: newStatus === "Won" 
                  ? "var(--success)" 
                  : (newStatus === "On Hold" ? "#ff9800" : (newStatus === "Not Granted" ? "var(--text-secondary)" : "var(--danger)")) 
              }}>
                {newStatus}
              </span>
            </div>
          </div>

          {newStatus === "Won" && (
            <>
              <div className="form-group">
                <label className="form-label" htmlFor="awardedDate" style={{ color: "var(--text-secondary)" }}>
                  Awarded Date *
                </label>
                <input
                  id="awardedDate"
                  type="date"
                  required
                  className="form-input"
                  value={awardedDate}
                  onChange={(e) => setAwardedDate(e.target.value)}
                  style={{ marginTop: "0.4rem" }}
                />
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="statusCustomerPo" style={{ color: "var(--text-secondary)" }}>
                  Customer PO # (Optional)
                </label>
                <input
                  id="statusCustomerPo"
                  type="text"
                  placeholder="e.g. CUST-PO-9876"
                  className="form-input"
                  value={customerPoNumber || ""}
                  onChange={(e) => setCustomerPoNumber && setCustomerPoNumber(e.target.value)}
                  style={{ marginTop: "0.4rem" }}
                />
              </div>
            </>
          )}

          {newStatus !== "Won" && (
            <p style={{ fontSize: "0.9rem", color: "var(--text-secondary)", margin: 0, lineHeight: 1.5 }}>
              Are you sure you want to mark this EST as <strong>{newStatus}</strong>? This will archive the proposal under <strong>Completed ESTs</strong>.
            </p>
          )}

          <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem", borderTop: "1px solid var(--border-color)", paddingTop: "1.25rem" }}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onConfirm}
              style={{
                backgroundColor: newStatus === "Won" 
                  ? "var(--success)" 
                  : (newStatus === "On Hold" ? "#ff9800" : (newStatus === "Not Granted" ? "var(--border-color)" : "var(--danger)")),
                color: (newStatus === "Won" || newStatus === "On Hold") ? "#000000" : "#ffffff",
                borderColor: "transparent"
              }}
            >
              Confirm Change
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
